import { combineReducers } from 'redux';
import websitesReducer from './websites/websites.reducer';
import userReducer from './user/user.reducer';
import notificationsReducer from './notifications/notifications.reducer';
import blacklistReducer from './blacklist/blacklist.reducer';
import conversationsReducer from './conversations/conversations.reducer';
import appReducer from './app/app.reducer';
import operatorReducer from './operators/operators.reducer';
import paymentsReducer from './payments/payments.reducer';
import departmentsReducer from './departments/departments.reducer';
import csReducer from './customerSuccess/cs.reducer';
import webhookReducer from './webhook/webhook.reducer';
import settingsReducer from './settings/settings.reducer';
import faqReducer from './faq/faq.reducer';
import convsArchiveReducer from './convsArchive/convsArchive.reducer';
import affiliateReducer from './affiliate/affiliate.reducer';
import appslistReducer from './appslist/appslist.reducer';
import knowledgeBaseReducer from './knowledgeBase/knowledgeBase.reducer';
import layoutReducer from './layout/layout.reducer';
import dashboardReducer from './dashboard/dashboard.reducer';
import userVisitsReducer from './userVisitsArchive/userVisitsArchive.reducer';

const rootReducer = combineReducers({
  websitesData: websitesReducer,
  userData: userReducer,
  conversationsData: conversationsReducer,
  customerSuccessData: csReducer,
  notificationsData: notificationsReducer,
  blacklistData: blacklistReducer,
  appData: appReducer,
  operatorsData: operatorReducer,
  paymentsData: paymentsReducer,
  departmentsData: departmentsReducer,
  webhooksData: webhookReducer,
  faqData: faqReducer,
  convsArchiveData: convsArchiveReducer,
  settingsData: settingsReducer,
  affiliateData: affiliateReducer,
  appslistData: appslistReducer,
  knowledgeBaseData: knowledgeBaseReducer,
  dashboardData: dashboardReducer,
  layoutData: layoutReducer,
  userVisitsData: userVisitsReducer,
});

export default rootReducer;
